import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_ayoh_miso_mayo_6_pack: FaireProductEntity = {
  token: "p_live_ayoh_miso_mayo_6_pack",
  type: "product",
  name: "Miso Mayo (6-pack)",
  brandToken: "b_live_ayoh_foods",
  brandName: "AYOH Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/9db431a3927dc41a9c03f6a605bb44dc2aab8f69cae06cc13e5b310040223eb3.jpeg?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
  priceDollars: 25.99,
  msrpDollars: 51.84,
  description: "AYOH miso mayo in a 6-pack format.",
  categoryTokens: ["cat_food-drink"],
  tags: ["live-shopping", "bestseller", "condiments"],
  isBestseller: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
